<template>
  <div class="position-relative">
    <v-app class="p-4">
      <v-card :loading="loading" class="container-fluid" style="margin-top: 4rem">
        <div class="row mx-auto">
          <div class="col-md-12">
            <div class="p-4 my-5">
              <div class="large-12  medium-12 small-12 filezone">
                <input type="file" id="files" ref="files" multiple @change="handleFilesUpload()"/>
                <p class="mt-2 text-center">
                  <i class="fa fa-cloud-upload-alt text-primary fa-5x d-block"></i>
                  فایل مورد نظر را اینجا بکشید ورها کنید.<br>یا برای آپلود فایل خود اینجا کلیک کنید.
                  <br>
                  اندازه عکس باید حداقل <label class="text-blue-500 font-black">۶۰۰ در ۶۰۰</label>
                  پیکسل باشد.
                </p>
              </div>
              <v-container fluid>
                <v-row class="my-3">
                  <v-col
                      v-for="(file, key) in files"
                      :key="file.name"
                      class="d-flex child-flex"
                      cols="12"
                      md="3"
                      :data-imgName="file.name"
                  >
                    <v-img
                        :src="file"
                        aspect-ratio="1"
                        :data-id="'files.'+key" :ref="'preview'+parseInt(key)"
                        id="imagess"
                    >
                      <v-icon
                          small
                          color="danger"
                          @click="removeFile(key)"
                          class="float-right border-secondary p-1 text-white bg-danger"
                          style="cursor: pointer ; font-size: 20px;"
                      >
                        mdi-trash-can-outline
                      </v-icon>
                    </v-img>
                  </v-col>
                </v-row>
              </v-container>

              <div v-if="files.length > 0">
                <div class="form-group col-md-3">
                  <v-text-field
                      label="نام دسته"
                      v-model="categories"
                      name="category"
                      clearable
                      clear-icon="mdi-close-circle-outline"
                      list="groups"
                      prepend-inner-icon="fa fa-pencil-alt"
                  ></v-text-field>
                  <datalist id="groups">
                    <option v-for="item in new Set(img.map((x)=>x.category))" :value="item">{{
                        item
                      }}
                    </option>
                  </datalist>
                </div>
                <v-btn class="btn-upload" v-status="'file_store'" @click="submitFiles()" :loading="loading"
                       :disabled="categories===''">
                  <span class="fa fa-upload mr-2"></span>
                  ثبت
                </v-btn>
              </div>

              <v-container v-if="img.length>0" fluid>
                <v-row class="my-3 mx-auto">
                  <v-col
                      v-for="(item , key) in img"
                      class="d-flex child-flex p-1 bg-white mx-2 my-1 rounded-circle shadow-lg position-relative"
                      cols="12"
                      :key="item.id"
                      md="2"
                  >
                    <v-img
                        :src="item.full_path"
                        aspect-ratio="1"
                        class="rounded-circle"

                    >
                      <v-icon
                          v-status="'file_destroy'"
                          small
                          color="danger"
                          @click="removeFromGallery(item.id)"
                          class="float-right p-1 text-white bg-danger m-5 rounded-circle position-absolute"
                          style="cursor: pointer ; font-size: 20px;top:0;right:-3%;z-index: 22222"
                      >
                        mdi-trash-can-outline
                      </v-icon>
                    </v-img>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </div>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";

export default {
  name: "uploader",
  components: {TitleRibbon, PicSelector},
  props: {
    'category': {
      required: true,
      type: String
    }
  },
  data: () => ({
    files: [],
    img: [],
    erroredPic: 0,
    successPic: 0,
    categories: "",
    refresh: true,
    loading: false
  }),
  methods: {
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          let reader = new FileReader();
          reader.addEventListener("load", function () {
            this.$refs['preview' + parseInt(i)][0].src = reader.result;
          }.bind(this), false);
          reader.readAsDataURL(this.files[i]);
        } else {
          this.$nextTick(function () {
            this.$refs['preview' + parseInt(i)][0].src = '/img/generic.png';
          });
        }
      }
    },
    handleFilesUpload() {
      const uploadedFiles = this.$refs.files.files;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
      this.getImagePreviews();
    },
    addFiles() {
      this.$refs.files
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews();
    },
    getImages() {
      this.loading = true
      $.ajax({
        url: `${url}/files?type=divar`,
        fn: this.getImages,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        type: "GET",
        success: (data) => {
          this.img = data.data;
          this.loading = false
        },
        error: function () {
          this.loading = false
        }
      })
    },
    removeFromGallery: function (key) {
      const vm = this;
      $.ajax({
        url: `${url}/files/${key}`,
        method: "DELETE",
        fn: this.removeFromGallery,
        params: [key],
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token
        },
        msg: true,
        success: function (res) {
          vm.img = [];
          setTimeout(() => {
            vm.getImages();
          }, 4000)
        }
      })
    },
    submitFiles(item = 0) {
      this.loading = true;

      let formData = new FormData();
      formData.append('category', this.categories);
      formData.append('file', this.files[item]);
      $.ajax({
        url: `${url}/files`,
        fn: this.submitFiles,
        params: [item],
        type: 'POST',
        data: formData,
        headers: {
          "Authorization": Token,
          "ACCEPT": "application/json"
        },
        contentType: false,
        processData: false,
        msg: this.files.length <= item + 1 && this.erroredPic === 0,
        reload: this,
      }).always((data) => {
        try {
          document.querySelectorAll('#imagess')[item].classList.add(data.status === true ? " " : "border-danger");
          this.erroredPic += 1;
        } catch (e) {
          // this.getImages();
        }

        item++;
        data.status === true ? this.successPic++ : this.erroredPic++;

        if (this.files.length > item)
          this.submitFiles(item);
        else {
          if (this.erroredPic <= 0) {
            setTimeout(() => {
              this.files = [];
              this.categories = ''
              this.getImages()
            }, 7000)
          } else {
            this.$nextTick(function () {
              this.$modal.error('خطا!', 'لظفا عکس های مشخص شده با کادر قرمز را حذف و با عکس درست جایگزین کنید و دوباره ثبت کنید.')
            })
            this.erroredPic = 0
          }

        }
        this.loading = false;
      })
    },
  },
  watch: {

    categories() {
      this.getImagePreviews()
    }
  },
  mounted() {
    this.getImages()
  }

}
</script>

<style>
.fa-pencil-alt {
  font-size: 12pt !important;
}

.border-danger {
  border: 2px solid #f44336 !important;
}

input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.filezone {
  outline: 3px dashed #163cd0;
  outline-offset: -3px;
  color: dimgray;
  padding: 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  background-color: #ddddeee0;
}

.filezone:hover {
  background: #ddddeee0;
}

.filezone p {
  font-size: 1.2em;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

.icon-cloud-up {
  color: #163cd0;
}
</style>